import { AuditTimeline } from '../../../shared/features/history/components/AuditTimeline';
import { useHistory } from '../../../shared/features/history/hooks/use-history';
import { DriverAvailabilityHistory } from './DriverAvailabilityHistory';

/** The driver's whole history: availability changes first, then field edits, status changes and document attach/replace, all audited against `entityType: 'driver'`. */
export function DriverHistoryTab({ driverId }: { driverId: string }) {
  const state = useHistory('driver', driverId, true);
  return (
    <div className="flex flex-col gap-8">
      <DriverAvailabilityHistory driverId={driverId} />
      <AuditTimeline state={state} />
    </div>
  );
}
